import { useEffect, useState } from 'react';
import { ensureInitialized, fetchAndActivate } from 'firebase/remote-config';
import { Logger } from '@utils';
import useRemoteConfig from '../useRemoteConfig';

const logger = new Logger('Remote Config');

/**
 * Activates and fetches Firebase Remote Config
 * @param {import('firebase/remote-config').RemoteConfig} configInstance - RemoteConfig instance to use
 * @returns {boolean} isReady - Indicates if RemoteConfig is ready
 */
export default function useRemoteConfigValues(configInstance) {
  const [isReady, setIsReady] = useState(false);
  const { remoteConfigActions } = useRemoteConfig();

  useEffect(() => {
    if (!configInstance) {
      logger.error('No remoteConfigInstance provided to useRemoteConfigValues');
      return;
    }

    /** */
    const getRemoteConfigValues = async () => {
      try {
        logger.log('Trying to initialize, fetch and activate the module');
        await ensureInitialized(configInstance);
        logger.log('Ensured that RemoteConfig is initialized');
        await fetchAndActivate(configInstance);
        logger.log('Values fetched successfully');
        setIsReady(true);
        remoteConfigActions.setAllValues();
      } catch (error) {
        logger.error('Error trying to initialize, fetch or activate the module', error);
      }
    };
    getRemoteConfigValues();
  }, [configInstance, remoteConfigActions]);

  return isReady;
}
